export const AppSettings = {
    appName: "DDDD",
    appIcon: "",//https://www.runebox.xyz/images/logo.png
}